<template>
  <div class="integration-header">
    <RexSearchSelect
      :current="currentIntegration"
      :data="options"
      width="10.75rem"
      @onChoose="(item) => onIntegrationChange(item)"
      :heading="heading"
      :objectValueIndex="1"
      class="capability-dropdown"
      id="search-select-capablity"
    />
  </div>
</template>
<script>
import RexSearchSelect from '@/rex-components/RexSearchSelect.vue';

export default {
  components: { RexSearchSelect },
  methods: {
    getIntegrations() {
      return [];
    },
    onIntegrationChange(item) {
      this.currentIntegration = item;
    },
  },
  data() {
    return {
      options: [
        {
          id: '1',
          label: this.$t('aws.all-integrations'),
        },
      ],
      heading: this.$t('integrations'),
      currentIntegration: {},
    };
  },
};
</script>
<style scoped>
.integration-header {
  display: flex;
}
</style>
